import { Injectable } from '@angular/core';
import { HqStop } from '../global/interfaces/hqStop';
import { Stop } from '../global/interfaces/stop';
import { StopTypeEnum } from '../global/interfaces/stopTypeEnum';

@Injectable()
export class StopFunctions {
  getCssClassForStop(stop, last) {
    let response;
    if (!stop.actualStartDate && !stop.actualEndDate) {
      response = 'route-incoming';
    }
    if (stop.actualStartDate && !stop.actualEndDate) {
      response = 'route-active';
    }
    if (stop.actualStartDate && stop.actualEndDate) {
      response = 'route-completed';
    }
    if (!last && !stop.actualEndDate) {
      response = response + ' route-path';
    } else if (!last && stop.actualEndDate) {
      response = response + ' route-path-finished';
    } else {
      response = response + ' route-last';
    }

    return response;
  }
  findContractJobDeliveryStops(stops: HqStop[]) {
    return stops.filter((stop) => stop.type.toLowerCase() === StopTypeEnum.delivery.toLowerCase());
  }

  displayActualOrPlannedDate(stop: HqStop | Stop) {
    return stop.actualStartDate ?? stop.plannedStartDate;
  }
}
